import React from 'react';
import AssessmentsForm from '../../../components/forms/AssessmentsForm';

export default function AssessmentsPageCreatePage() {
  return <AssessmentsForm />;
}
